import { forwardRef } from "react";
import "./button.scss";

const ButtonAtom = forwardRef(function ButtonAtom(props, ref) {
	const { className, onClick, children, disabled, title, ...rest } = props;

	const buttonClass = `custom-button ${className || "btn btn-primary"}`;

	const button = (
		<button
			ref={ref}
			type="button"
			className={buttonClass}
			onClick={onClick}
			disabled={disabled}
			{...rest}
		>
			{children}
		</button>
	);

	// Wrap disabled button in a span to show cursor and tooltip on hover
	if (disabled) {
		return (
			<span
				className="d-inline-block cursor-not-allowed"
				tabIndex={0}
				title={title}
			>
				{button}
			</span>
		);
	}

	return button;
});

export default ButtonAtom;

